<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-17 13:04:41
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="msgbox" v-if="posterImg">
      <img class="poster" :src="posterImg" alt />
      <div class="seve">「长按图片，保存你的个人专属海报」</div>
      <div class="back" @click="clickClose">返回</div>
    </div>
  </div>
</template>

<script>
import Canvastoimg from "wtc-canvastoimg";
export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      title: "",
      message: "",
      callback: null,
      posterImg: "",
      qrcodeUrl: "", //https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1578572258000-45.png
    };
  },
  watch: {
    value: function (newVal) {
      this.posterImg = "";
      if (newVal) {
        this.$showLoading();

        this.createImg();
        if (!this.qrcodeUrl) {
          let tmpUrl = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}`;
          this.$httpdf
            .get(
              this.apiHost + 'common/createQrCode/dynamic',
              {
                htmlUrl: tmpUrl,
                imgUrl: "",
                platformId: this.$config.platformId,
              }
            )
            .then((data) => {
              console.log(data);
              this.qrcodeUrl = data.data;
              //   console.log(url)
              this.createImg();
            });
        } else {
          this.createImg();
        }
      }
    },
  },
  computed: {},
  methods: {
    createImg() {
      // const txtList = [
      //   {
      //     txt1: '2021年将多吃不胖，',
      //     txt2: '积极又向上'
      //   },
      //   {
      //     txt1: '2021年将锦鲤附身，',
      //     txt2: '好运一整年'
      //   },
      //   {
      //     txt1: '2021年将找到真爱，',
      //     txt2: '脱单秀恩爱'
      //   },
      //   {
      //     txt1: '2021年将事业有成，',
      //     txt2: '升职又加薪'
      //   }
      // ]
      // const chooseTxt = txtList[parseInt(Math.random()*4)] || txtList[0]
      console.log("this.$userInfo", this.$userInfo);
      let posterUrl = this.imgHost + "share-bg.jpg?x-oss-process=image/resize,p_88";
      /* 初始化类 */
      let sharpness = 3;
      let cvsImgData = [
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 1,
          x: 0,
          y: 0,
          width: 375 * sharpness,
          height: 610 * sharpness,
          content: posterUrl,
        },
        // {
        //   type: "img", //背景图
        //   shape: "", //默认是矩形，  'arc代表画圆'
        //   zIndex: 2,
        //   x: 53 * sharpness,
        //   y: 335 * sharpness, //370-34.75
        //   width: 270 * sharpness,
        //   height: 259 * sharpness,
        //   content: contentUrl
        // },
        // {
        //   type: "img", //头像
        //   shape: "arc",
        //   zIndex: 2,
        //   x: 163 * sharpness,
        //   y: 302 * sharpness,
        //   width: 50 * sharpness,
        //   height: 50 * sharpness,
        //   content: this.$userInfo.headImgUrl,
        // },
        {
          type: "img", //二维码
          zIndex: 2,
          x: 113 * sharpness,
          y: 331 * sharpness,
          width: 150 * sharpness,
          height: 150 * sharpness,
          content: this.qrcodeUrl,
        },
        // {
        //   type: "text",
        //   zIndex: 2,
        //   fontSize: `${13 * sharpness}px 微软雅黑`,
        //   x: 132 * sharpness,
        //   y: 430* sharpness,
        //   content: chooseTxt.txt1,
        //   color: "#86004C",
        // },
        // {
        //   type: "text",
        //   zIndex: 2,
        //   fontSize: `${13 * sharpness}px 微软雅黑`,
        //   x: 155 * sharpness,
        //   y: 445* sharpness,
        //   content: chooseTxt.txt2,
        //   color: "#86004C",
        // },
      ];

      const cvsimg = new Canvastoimg({
        width: 375 * sharpness, //画布宽度
        height: 610 * sharpness, //画布高度
        color: "#FFB471", //画布背景色
        data: cvsImgData,
      });
      cvsimg.down().then((canvas) => {
        /* 获取到的是canvas对象 */
        this.$hideLoading();
        this.posterImg = canvas.toDataURL("image/jpg");
        setTimeout(() => {
          this.$showToast({
            message: "请长按保存！",
            duration: 2000,
          });
        }, 500);
      });
    },
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="css" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.msgbox {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.poster {
  width: 80%;
}
.seve {
  font-size: 15px;
  line-height: 18px;
  font-family: PingFang SC;
  color: rgba(255, 255, 255, 1);
  margin-top: 15px;
  text-align: center;
}
.back {
  width: 100px;
  height: 32px;
  background: linear-gradient(180deg, #47C2D6, #1D65A2);
  border-radius: 5px;
  font-size: 18px;
  font-family: PingFang SC;
  color: #fff;
  line-height: 32px;
  margin-top: 15px;
  text-align: center;
}
.msgbox .close {
  position: absolute;
  top: -1.65rem;
  right: -1.65rem;
  width: 1rem;
  height: 1rem;
  z-index: 1001;
}
</style>